export default "__VITE_ASSET__CutfLaE3__"